<div class="row g-0">
  <div class="col-12 col-sm-6 col-md-8" style="padding-right: 2rem;">
    <div class="">
      <label class="form-label active" for="document_id">Codice</label>
      <input class="form-control ng-untouched ng-pristine" type="text" aria-invalid="false" disabled="" [value]="id" id="document_id">
    </div>
    <div class="mt-3 mb-3">
      <label class="form-label active" for="document_title">Titolo</label>
      <input class="form-control ng-untouched ng-pristine" [value]="model!.title" type="text" disabled="" id="document_title">
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <label class="form-label active">Anteprima/Download</label>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
          <button class="btn btn-secondary btn-icon w-100" (click)="preview()">
            <span class="rounded-icon">
              <svg class="icon icon-secondary"><use href="/assets/svg/sprites.svg#it-file"></use></svg>
            </span>
            <span>Preview document</span>
          </button>
      </div>
      <div class="col-6">
        <button class="btn btn-secondary btn-icon w-100" (click)="download(model!.title)">
            <span class="rounded-icon">
              <svg class="icon icon-secondary"><use href="/assets/svg/sprites.svg#it-download"></use></svg>
            </span>
          <span>Download document</span>
        </button>
      </div>
    </div>

  </div>
  <div class="col-6 col-md-4" style="margin-top: 1.8rem">
    <img [src]="src" [title]="model!.title" width="100%" style="border: 1px solid #b2b2b2">
  </div>
</div>
